export const ASSETS_TYPE = 'assets';
export const LIABILITIES_TYPE = 'liabilities';



// WEBPACK FOOTER //
// ./src/utils/templateHistoryTypes.js